import {HTTP} from "./util"

let UserRegistrationWrapper = {

    init : config => {

        return {

            Create: async function (data) {
                const url = `${config.url}/userregistrations`;

                let p = Promise.resolve();
                let response;
                try{
                    response = await HTTP.post(url, data);
                    if(response.ok){
                        p = Promise.resolve( { status : response.status  , data : data } );
                    }
                    else{
                        if(response.status >= 500 ){
                            p = Promise.reject({status : response.status , message : "Backend generated error"});

                        }
                        else{
                            p = Promise.reject( { status : response.status , data : data , message : response.statusText })

                        }
                    }

                }
                catch(e){
                    p = Promise.reject({ status : response.status , message : e.message})
                }


                return p;
            }
        }
    }


};

let UserRegistration = (config) => {

    return UserRegistrationWrapper.init(config);
};
export {
    UserRegistration
}